import { Alert, AlertDescription, Button } from '@design-system';
import { Link } from 'react-router-dom';
import { useIntakeChangeRequest } from './use-intake-change-request';

export function IntakeChangeRequestBanner({ clientId }: { clientId: string }) {
  const { data } = useIntakeChangeRequest(clientId);
  const reviewPath = `/clients/${clientId}/intake-change-review`;

  if (data?.request?.status !== 'pending') return null;

  return (
    <Alert className="mx-auto mb-4 max-w-5xl">
      <AlertDescription className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
        <span>Your advisor requested updates to your intake answers. Review the changes.</span>
        <Button
          asChild
          size="sm"
        >
          <Link to={reviewPath}>Review request</Link>
        </Button>
      </AlertDescription>
    </Alert>
  );
}
